import React from 'react';
import BaseInvoiceList from './BaseInvoiceList';
import LocalizedMessage from 'react-l10n';
import moment from 'moment';
import { axiosRequestReciprocalInvoices } from '../../actions/invoiceActions';
import { currencyDisplay, currencyObject } from '../../_utils';

const getHeading = () => {
    switch (window.localeCountry) {
        case 'Canada':
            return <LocalizedMessage id={'RECIPROCAL_RECEIPTS.HEADING_CA'}/>;
        case 'New Zealand':
            return <LocalizedMessage id={'RECIPROCAL_RECEIPTS.HEADING_NZ'}/>;
        case 'United States':
            return <LocalizedMessage id={'RECIPROCAL_RECEIPTS.HEADING_US'}/>;
        default:
            return <LocalizedMessage id={'RECIPROCAL_RECEIPTS.HEADING'}/>;
    }
};

function ReciprocalInvoiceList(props) {
    const callback = {
        updateTableProps: (
            tableProps,
            { toggleRefineResultsModal, getOrderDetailLink }
        ) => {
            const newTableProps = { ...tableProps };

            newTableProps.list.columns = [
                {
                    Header: () => {
                        return (
                            <React.Fragment>
                                <span className='react-table__heading'>
                                    <LocalizedMessage
                                        id={'INVOICE.INVOICE_NO'}
                                    />
                                </span>
                                <span className='react-table__sort-icon' />
                            </React.Fragment>
                        );
                    },
                    Cell: (row) => {
                        const { InternalItemID } = row.original;

                        return (
                            <React.Fragment>
                                <span className='react-table__info'>
                                    {InternalItemID}
                                </span>
                            </React.Fragment>
                        );
                    },
                    sortable: true,
                    minWidth: undefined,
                    accessor: 'InternalItemID',
                },
                {
                    Header: () => {
                        return (
                            <React.Fragment>
                                <span className='react-table__heading'>
                                    <LocalizedMessage id={'INVOICE.ORDER_NO'} />
                                </span>
                                <span className='react-table__sort-icon' />
                            </React.Fragment>
                        );
                    },
                    Cell: (row) => {
                        const { Order } = row.original;
                        const InternalItemID =
                            Order && Order.InternalItemID
                                ? Order.InternalItemID
                                : null;

                        return (
                            <React.Fragment>
                                <span className='react-table__info'>
                                    {InternalItemID}
                                </span>
                            </React.Fragment>
                        );
                    },
                    sortable: true,
                    minWidth: undefined,
                    accessor: 'Order.InternalItemID',
                },
                {
                    Header: () => {
                        const memberType = window.memberType.toLowerCase();
                        return (
                            <React.Fragment>
                                <span className='react-table__heading'>
                                    {memberType === 'wholesaler' ? (
                                        <LocalizedMessage
                                            id={
                                                'INVOICE.RESELLER_BUSINESS_NAME'
                                            }
                                        />
                                    ) : (
                                        <LocalizedMessage
                                            id={
                                                'INVOICE.WHOLESALER_BUSINESS_NAME'
                                            }
                                        />
                                    )}
                                </span>
                            </React.Fragment>
                        );
                    },
                    Cell: (row) => {
                        return (
                            <React.Fragment>
                                <span className='react-table__info'>
                                    {row.value}
                                </span>
                            </React.Fragment>
                        );
                    },
                    sortable: false,
                    minWidth: undefined,
                    accessor: 'ResellerBusinessName',
                },
                {
                    Header: () => {
                        return (
                            <React.Fragment>
                                <span className='react-table__heading'>
                                    <LocalizedMessage
                                        id={'INVOICE.PLACED_ON'}
                                    />
                                </span>
                                <span className='react-table__sort-icon' />
                            </React.Fragment>
                        );
                    },
                    Cell: (row) => {
                        const { Order } = row.original;
                        const momentDate =
                            Order && Order.Placed ? moment(Order.Placed) : null;

                        return (
                            <React.Fragment>
                                <span className='react-table__info'>
                                    {momentDate != null
                                        ? momentDate.format('DD/MM/YYYY')
                                        : '-'}
                                </span>
                            </React.Fragment>
                        );
                    },
                    headerClassName: 'hidden-xs',
                    className: 'hidden-xs',
                    sortable: true,
                    minWidth: undefined,
                    accessor: 'Order.Placed',
                },
                {
                    Header: () => {
                        return (
                            <React.Fragment>
                                <span className='react-table__heading'>
                                    <LocalizedMessage id={'INVOICE.PAID_ON'} />
                                </span>
                                <span className='react-table__sort-icon' />
                            </React.Fragment>
                        );
                    },
                    Cell: (row) => {
                        const momentDate = row.value ? moment(row.value) : null;
                        return (
                            <React.Fragment>
                                <span className='react-table__info'>
                                    {momentDate != null
                                        ? momentDate.format('DD/MM/YYYY')
                                        : '-'}
                                </span>
                            </React.Fragment>
                        );
                    },
                    sortable: true,
                    minWidth: undefined,
                    accessor: 'PaidDate',
                },
                {
                    Header: () => {
                        return (
                            <React.Fragment>
                                <span className='react-table__heading'>
                                    <LocalizedMessage id={'INVOICE.STATUS'} />
                                </span>
                            </React.Fragment>
                        );
                    },
                    Cell: (row) => {
                        return (
                            <React.Fragment>
                                <span className='react-table__info'>
                                    {row.value}
                                </span>
                            </React.Fragment>
                        );
                    },
                    sortable: false,
                    minWidth: undefined,
                    accessor: 'Status',
                },
                {
                    Header: () => {
                        return (
                            <React.Fragment>
                                <span className='react-table__heading'>
                                    <LocalizedMessage
                                        id={'INVOICE.PAID_AMOUNT'}
                                    />
                                </span>
                                <span className='react-table__sort-icon' />
                            </React.Fragment>
                        );
                    },
                    Cell: (row) => {
                        const { CurrencyDisplayCode, CurrencyFormat } = row.original;
                        const { locale } = currencyObject;

                        return (
                            <React.Fragment>
                                <span className='react-table__info'>
                                    {currencyDisplay(row.value, CurrencyDisplayCode, CurrencyFormat, locale)}
                                </span>
                            </React.Fragment>
                        );
                    },
                    sortable: true,
                    headerClassName: 'hidden-xs',
                    className: 'hidden-xs',
                    minWidth: undefined,
                    accessor: 'Paid',
                },
                {
                    expander: true,
                    Expander: ({ isExpanded, ...rest }) => {
                        return (
                            <React.Fragment>
                                <button
                                    type='button'
                                    className='react-table__extra-data-toggle'
                                >
                                    <span className='icon icon-chevron-thick' />
                                </button>
                            </React.Fragment>
                        );
                    },
                    headerClassName: 'visible-xs',
                    className: 'visible-xs',
                    width: 45,
                    sortable: false,
                    accessor: 'ID',
                },
            ];

            newTableProps.list.SubComponent = (row) => {
                const { Order } = row.original;
                const momentPlacedDate =
                    Order && Order.Placed ? moment(Order.Placed) : null;

                return (
                    <div className='react-table__extra-data'>
                        <div className='row'>
                            <div className='col-xs-4 vspace vspace--small'>
                                <div className='react-table__heading'>
                                    <LocalizedMessage
                                        id={'INVOICE.PLACED_ON'}
                                    />
                                </div>
                                <div className='react-table__info'>
                                    {momentPlacedDate != null
                                        ? momentPlacedDate.format('DD/MM/YYYY')
                                        : '-'}
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-xs-12 vspace vspace--small'>
                                <div className='data-table__heading'>
                                    <LocalizedMessage id={'VIEW'} />
                                </div>
                                <div className='data-table__info'>
                                    <a
                                        href={getOrderDetailLink(
                                            row.original.ID
                                        )}
                                        className='button button--grey-border'
                                    >
                                        <LocalizedMessage id={'VIEW_DETAILS'} />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            };

            return newTableProps;
        },
    };

    return (
        <React.Fragment>
            <BaseInvoiceList
                heading={getHeading()}
                axiosRequest={axiosRequestReciprocalInvoices}
                graphQLPattern={'readReciprocalInvoices'}
                callback={callback}
                getOrderDetailLink={(row) =>
                    `${window.baseURL}account/invoices/view/${row.original.ID}/?type=reciprocal`
                }
            />
        </React.Fragment>
    );
}

export default ReciprocalInvoiceList;
